import React, {Component} from 'react';
import { Redirect  } from "react-router-dom";
import '../App.css';
import '../css/all.css';



import UpperMenu from '../components/upper_menu/upper_menu.component'
import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';




class ErrorPage extends Component {


    state = {
        redirect:null
    }


  componentDidMount = () => {
          
  }



  backHomePage = () => {
    this.setState({ redirect: "/" }); 
}


setClosed = () =>  {
    this.setState({ redirect: "/" }); 
}

  render() {         
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    } 

    return (      
        <div>                                   
            <div className="hp_banner">
                <UpperMenu   
                    personData={this.props.personData}
                    onLoggedOutRefresh={this.props.onLoggedOutRefresh}/>

            </div>
    
            <div className="hp_container">                                          
            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg">

                            <div className="close_arrow pointer zindex1000" onClick={this.setClosed}></div>

                            <div className="modal_order_inner_bg">
                              
                                    <div className="modal_order_top">                            
                                        <div className="modal_order_title1"> תקלה זמנית</div>
                                    </div>


                                    <div className="modal_order_title_hotel directionRtl">
                                    קיימת תקלה זמנית בשירות,
                                    נסה במועד מאוחר יותר.
                                    </div>

                                    <div className="modal_order_title_hotel directionRtl">
                                       פנה למנהל המערכת.
                                    </div>



                                <div className="modal_order_confirmation_container">
                                
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button"
                                                onClick={() => this.backHomePage()}>
                                            <span className="hp_search_main_button_title">
                                            חזרה לדף הראשי
                                            </span>
                                        </div>
                                    </div>
                                            
                                </div>
                            </div>
                        </div>
                    </div>                
                </React.Fragment>
            </div>
                                
            </div>

            <div className="hp_footer">
            </div>
        </div>
    )
  }
}



export default ErrorPage;



